import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

import CloseIcon from '@material-ui/icons/Close';

import RedButton from 'app/components/buttons/RedButton';
import Loading from 'app/components/loaders/Loading';
import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

export default function DeletePostDialog(props) {

    const { post, open, onClose, onDelete, onClosed } = props;
    const classes = useStyles();
    const api = useApi();

    const [ errors, setErrors ] = useState({});
    const [ loading, setLoading ] = useState(false);

    const deletePost = () => {
        setLoading(true);

        api.delete('/post/' + post.id).then(res => {
                onDelete();
            }).catch(error => {
                setLoading(false);

                if (error?.response?.data?.errors) {
                    setErrors(error.response.data.errors)
                }
            });
    };

    const isError = field => {
        if (errors[field]) return true;
        return false;
    };

    const getErrorMessage = field => {
        if (isError(field)) return errors[field];
        return "";
    };

    const onExited = () => {
        setLoading(false);
        onClosed();
    }

    return (
        <Dialog
            aria-labelledby="delete-post-dialog-title"
            open={open}
            fullWidth
            maxWidth="sm"
            onClose={onClose}
            onExited={onExited}
            >
            <Loading isLoading={loading}/>
            <DialogTitle id="delete-post-dialog-title">
                <span>Delete Post</span>
                <IconButton
                    aria-label="Cancel"
                    className={classes.closeButton}
                    onClick={onClose}
                    disabled={loading}
                    >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you would like to delete this post?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    disabled={loading}
                    >
                    Cancel
                </Button>
                <RedButton
                    onClick={deletePost}
                    disabled={loading}
                    variant="contained"
                    >
                    Delete
                </RedButton>
            </DialogActions>
        </Dialog>
    );
}
